import { CheckCircle2 } from "lucide-react";
import { strengths } from "./summaryModel";
import { S } from "./summaryCopy";
import { T } from "./i18n";

// "Was schon gut läuft": only facts the free data proves (rating >= 4.5, a top-3
// Maps rank, pillars at full score). Renders nothing when none qualifies, so the
// connecting sentence never introduces an empty list.
export default function StrengthsStrip({ data, lang }) {
  const items = strengths(data);
  if (!items.length) return null;
  const C = (S[lang] || S.de).strengths;
  const labels = (T[lang] || T.de).pillars;
  const text = (s) => (s.id === "pillarFull" ? C.pillarFull(labels[s.args[0]], s.args[1], s.args[2]) : C[s.id](...s.args));
  return (
    <div data-testid="strengths-strip" className="mt-4 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-950 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-100">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-emerald-800 dark:text-emerald-300">{C.title}</h3>
      <ul className="mt-2 flex flex-wrap gap-2">
        {items.map((s, i) => (
          <li key={`${s.id}-${i}`} className="inline-flex items-center gap-1.5 rounded-full bg-white/70 px-3 py-1 text-sm font-medium dark:bg-emerald-900/40">
            <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" /> {text(s)}
          </li>
        ))}
      </ul>
      <p className="mt-3 text-base">{C.bridge}</p>
    </div>
  );
}
